var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"input",tag:"domel",class:{'has-focus': _vm.hasFocus, 'has-value': _vm.hasValue},attrs:{"value":_vm.value},on:{"input":_vm.checkValue,"focus":_vm.onFocus,"blur":_vm.onBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }